import { r as registerInstance, h } from './index-5faac9d7.js';
import { t as tryParse, a6 as transformLocaleToBCP47LanguageTag } from './index-39f51a91.js';
import { D as Direction } from './types-e54f4a51.js';
import { g as getContextDirection } from './contextDirection-33f260e3.js';
import './currency-49e0d692.js';
import './_commonjsHelpers-7db8bc26.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_nodeUtil-549406aa.js';
import './_Stack-cf94d4e7.js';

const myProductsCss = "@page {width:595px;height:975px;counter-increment:page}";

const MyProducts = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.myProducts = undefined;
    this.experienceMyProducts = undefined;
    this.allProductsConfig = undefined;
    this.lists = undefined;
    this.config = undefined;
    this.labels = undefined;
    this.tableNameLabel = undefined;
    this.tableQtyLabel = undefined;
    this.tableSubtotalLabel = undefined;
    this.isPriceEnabledOnSite = false;
    this.locale = undefined;
    this.contextDirection = undefined;
    this._myProducts = undefined;
    this._experienceMyProducts = undefined;
    this._myProductsConfig = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    this.myProducts = (_a = tryParse(this._myProducts)) !== null && _a !== void 0 ? _a : this.myProducts;
    this.experienceMyProducts = (_b = tryParse(this._experienceMyProducts)) !== null && _b !== void 0 ? _b : this.experienceMyProducts;
    this.allProductsConfig = (_c = tryParse(this._myProductsConfig)) !== null && _c !== void 0 ? _c : this.allProductsConfig;
    this.lists = (_d = this.myProducts) === null || _d === void 0 ? void 0 : _d.lists;
    this.config = (_e = this.experienceMyProducts) === null || _e === void 0 ? void 0 : _e.conf;
    this.labels = (_f = this.experienceMyProducts) === null || _f === void 0 ? void 0 : _f.labels;
    this.tableNameLabel = (_g = this === null || this === void 0 ? void 0 : this.labels) === null || _g === void 0 ? void 0 : _g.giftlistTableName;
    this.tableQtyLabel = (_h = this === null || this === void 0 ? void 0 : this.labels) === null || _h === void 0 ? void 0 : _h.giftlistTableQty;
    this.tableSubtotalLabel = (_j = this === null || this === void 0 ? void 0 : this.labels) === null || _j === void 0 ? void 0 : _j.giftlistTableSubtotal;
    this.isPriceEnabledOnSite = (_k = this === null || this === void 0 ? void 0 : this.config) === null || _k === void 0 ? void 0 : _k.isPriceEnabledOnSite;
    const hreflang = (_m = (_l = this.allProductsConfig) === null || _l === void 0 ? void 0 : _l.context) === null || _m === void 0 ? void 0 : _m.hreflang;
    this.locale = (hreflang && typeof hreflang === 'string')
      ? hreflang
      : transformLocaleToBCP47LanguageTag((_o = this.allProductsConfig) === null || _o === void 0 ? void 0 : _o.context.locale);
    const cartConfigDirection = this.allProductsConfig.context.direction;
    this.contextDirection = getContextDirection(cartConfigDirection);
  }
  renderSingleProducts() {
    const singleProductsList = [];
    if (this.lists.length === 0)
      return;
    this.lists.forEach((item) => {
      if (item.type === "single" && item.products.length) {
        singleProductsList.push(item);
      }
    });
    return (h("pes-my-products-single-table", { locale: this.locale, lists: singleProductsList, config: this.config, labels: this.labels, contextDirection: this.contextDirection }));
  }
  renderGroupProducts() {
    const groupProductsList = [];
    if (this.lists.length === 0)
      return;
    this.lists.forEach((item) => {
      if (item.type === "group" && item.products.length) {
        groupProductsList.push(item);
      }
    });
    return (h("pes-my-products-group-table", { locale: this.locale, lists: groupProductsList, config: this.config, labels: this.labels, contextDirection: this.contextDirection }));
  }
  renderHeader() {
    if (!this.lists)
      return null;
    const { myProductsTitle, dataSheetDate } = this.lists[0].products[0];
    return (h("pes-my-products-header", { titleLabel: myProductsTitle, date: dataSheetDate, tableNameLabel: this.tableNameLabel, tableQtyLabel: this.tableQtyLabel, tableSubtotalLabel: this.tableSubtotalLabel, isPriceEnabledOnSite: this.isPriceEnabledOnSite }));
  }
  renderFooterNotes() {
    var _a, _b;
    if (!this.lists)
      return null;
    const { weeePriceLabel } = this.lists[0].products[0].weeePrices;
    const { myProductsDisclaimer } = this.lists[0].products[0];
    if (((_a = this.config) === null || _a === void 0 ? void 0 : _a.isWeeePricesEnabled) && myProductsDisclaimer && weeePriceLabel) {
      return (h("pes-my-products-footer-notes", { weeePriceLabel: weeePriceLabel, disclaimer: myProductsDisclaimer, contextDirection: this.contextDirection }));
    }
    if (!((_b = this.config) === null || _b === void 0 ? void 0 : _b.isWeeePricesEnabled) && myProductsDisclaimer) {
      return h("pes-my-products-footer-notes", { disclaimer: myProductsDisclaimer });
    }
  }
  renderFooter() {
    if (!this.lists)
      return null;
    const { dataSheetDate } = this.lists[0].products[0];
    if (this.contextDirection === Direction.rtl) {
      return h("pes-my-products-rtl-footer", { date: dataSheetDate });
    }
    return h("pes-my-products-ltr-footer", { date: dataSheetDate });
  }
  render() {
    var _a;
    return (h("div", { class: "pdf-rtl-selector", dir: (_a = this.contextDirection) !== null && _a !== void 0 ? _a : Direction.auto }, this.renderHeader(), this.renderFooterNotes(), this.renderFooter(), this.renderSingleProducts(), this.renderGroupProducts(), h("pes-my-products-total", { locale: this.locale, lists: this.lists, isPriceEnabledOnSite: this.isPriceEnabledOnSite })));
  }
};
MyProducts.style = myProductsCss;

export { MyProducts as pes_my_products };
